import "../../../../css/modal/Modal.css";
import "../../../../css/modal/TeacherManagementModal.css"
import {useEffect, useState} from "react";
import proxy from "../../../../utils/Proxy";
import Pagination from "../../../footer/Pagination";
import {getDateString, moveModal} from "../../../../utils/Utils";
import UserLessonListModal from "../../../modal/UserLessonListModal";

let TeacherInChargeModal = (props) => {
    let [inChargeList, setInChargeList] = useState([]);
    let [listLength, setListLength] = useState(0);
    let [page, setPage] = useState(1);

    let [selectedUser, setSelectedUser] = useState(0);
    let [selectedUsername, setSelectedUsername] = useState("");

    let [childModalOpened, setChildModalOpened] = useState(false);
    let [needUpdate, setNeedUpdate] = useState(false)

    useEffect(() => {
        let teacher = props.teacher;
        proxy.get("/adminapi/teachers/in_charge/" + teacher.teacherid + "?page=" + page + "&count=" + 6).then(res => {
            setInChargeList(res.data.data);
            setListLength(res.data.totalLength);
            setNeedUpdate(false)
        })
    }, [page, needUpdate, props.teacher])
    let getInChargeList = () => {
        let ret = [];
        for (let userInfo of inChargeList) {
            let key = userInfo.username + ":" + userInfo.userid
            ret.push(<div className="in_charge-row" key={key}>
                <div className="in_charge-cell">
                    <p>{userInfo.username}</p>
                </div>
                <div className="in_charge-cell">
                    <p>{getDateString(new Date(userInfo.latestLesson.due))}</p>
                </div>
                <div className="in_charge-cell">
                    <p>{userInfo.latestLesson.hour}시</p>
                </div>
                <div className="in_charge-cell">
                    <div className="teacher-management-lesson-list-button" onClick={() => {
                        setSelectedUser(userInfo.userid)
                        setSelectedUsername(userInfo.username)
                        setChildModalOpened(true)
                    }}>
                        <p>레슨 내역</p>
                    </div>
                </div>
            </div>)
        }
        return ret;
    }
    return (<>
        <div className="modal-container">
            <div className="modal" id="teacher-in_charge-modal">
                <div className="modal-content-container">
                    <div className="modal-header" onMouseDown={e => moveModal(e, "teacher-in_charge-modal")}>
                        <div className="modal-title">
                            <p>담당학생 목록</p>
                        </div>
                        <div className="modal-close-button" onClick={() => props.setClosed()}>
                        </div>
                    </div>
                    <div className="modal-content in_charge-table-container">
                        <div className="in_charge-header">
                            <div className="in_charge-row">
                                <div className="in_charge-cell">
                                    <p className="in_charge-column-text">
                                        이름
                                    </p>
                                </div>
                                <div className="in_charge-cell">
                                    <p className="in_charge-column-text">
                                        최근 레슨 예약
                                    </p>
                                </div>
                                <div className="in_charge-cell">
                                    <p className="in_charge-column-text">
                                        예약 시간
                                    </p>
                                </div>
                                <div className="in_charge-cell">
                                    <p className="in_charge-column-text">
                                        레슨 내역
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="in_charge-table">
                            {getInChargeList()}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <Pagination setPage={setPage.bind(this)} page={page} listLength={listLength}
                                    countPerPage={6}
                        />
                    </div>
                </div>
            </div>
        </div>
        {childModalOpened ? <UserLessonListModal userid={selectedUser} setOpened={setChildModalOpened.bind(this)}
                                                 opened={childModalOpened} username={selectedUsername} data={props.data}
                                                 needUpdate={needUpdate} setNeedUpdate={setNeedUpdate.bind(this)}

        /> : null}
    </>);
}
export default TeacherInChargeModal;